import { render, staticRenderFns } from "./AboutWeb.vue?vue&type=template&id=b8a76cc0&scoped=true&"
import script from "./AboutWeb.vue?vue&type=script&lang=js&"
export * from "./AboutWeb.vue?vue&type=script&lang=js&"
import style0 from "./AboutWeb.vue?vue&type=style&index=0&id=b8a76cc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a76cc0",
  null
  
)

export default component.exports